import $ from 'jquery';
import LocalStorageService from './LocalStorageService';

export default class {
  constructor() {
    this.$progressBar = null;
    this.localStorageService = new LocalStorageService();
    this.init();
  }

  init() {
    this.$progressBar = $('.progress-bar');

  }

  delayedFill() {
    if (!this.$progressBar) return;

    this.$progressBar.animate({ width: '100%' }, 'slow', () => {
      if (window._env.redirectUrl) {
        // once complete clear local storage and redirect user
        window.location.href = window._env.redirectUrl;
        this.localStorageService.clear();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/ProgressBarController.js